import { observer } from 'mobx-react';
import React, { useState } from 'react';

import { Button, Dialog, DialogContent, DialogTitle, LinearProgress, TextField } from '@mui/material';

import API from 'app/API';
import useStores from 'hooks/use-stores';

const Login: React.FC = () => {
    const { userStore, dialogStore } = useStores();
    const { openSignupDialog, openRecoveryDialog, closeAll, loginDialogOpen } = dialogStore;

    const [state, setState] = useState({
        email: '',
        password: '',
        error: '',
        loading: false
    });

    const handleEnterKey = (e) => {
        if (e.charCode === 13) {
            onLogin();
        }
    };

    const handleEmailChange = (event) => setState((state) => ({ ...state, email: event.target.value }));
    const handlePasswordChange = (event) => setState((state) => ({ ...state, password: event.target.value }));

    const onLogin = () => {
        setState((state) => ({ ...state, loading: true }));
        API.fetchWithToken(API.LOGIN, {
            email: state.email,
            password: state.password
        }).then((response) => {
            let error = response.result === 'error' ? response.data.error : '';

            if (error && response.data.errorCode === 118) {
                error = `User is not activated. \n Follow instructions in email or click RECOVER PASS`;
            }

            if (response.result === 'OK') {
                userStore.loadUser();
                userStore.loadLicenseList();
                userStore.loadEmailSubscriptions();
                userStore.loadWebhookSubscriptions();
                dialogStore.closeAll();
            }

            setState((state) => ({ ...state, loading: false, error: error }));
        });
    };

    return (
        <Dialog maxWidth="xs" open={loginDialogOpen} className="vulners-dialog" onClose={closeAll}>
            <DialogTitle>{'Login'}</DialogTitle>
            <DialogContent>
                <TextField fullWidth name="email" label="Email" onChange={handleEmailChange} />
                <br />
                <TextField
                    fullWidth
                    name="password"
                    type="password"
                    label="Password"
                    onChange={handlePasswordChange}
                    onKeyPress={handleEnterKey}
                />
                <br />
                <div className="vulners-dialog-error-text">{state.error}</div>
                {state.loading && <LinearProgress variant="indeterminate" />}
                <Button
                    fullWidth
                    size="large"
                    color="primary"
                    variant="contained"
                    onClick={onLogin}
                    disabled={state.loading}
                >
                    {'Login'}
                </Button>

                <br />
                <div className="vulners-divider-20"></div>
                <div className="display-flex flex-between">
                    <Button onClick={openSignupDialog} disabled={state.loading}>
                        {'Sign Up'}
                    </Button>

                    <Button onClick={openRecoveryDialog} disabled={state.loading}>
                        {'Recover Pass'}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default observer(Login);
